import React, { useState, useEffect } from 'react';
import axios from 'axios';

const apiURL = import.meta.env.VITE_ENVIRONMENT === "development" ? "http://localhost:5000" : import.meta.env.VITE_API_URL;

const cryptoIcons = {
  bitcoin: "https://cryptologos.cc/logos/bitcoin-btc-logo.svg?v=014",
  ethereum: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=014",
  ripple: "https://cryptologos.cc/logos/ripple-xrp-logo.svg?v=014",
  litecoin: "https://cryptologos.cc/logos/litecoin-ltc-logo.svg?v=014",
  cardano: "https://cryptologos.cc/logos/cardano-ada-logo.svg?v=014",
  polkadot: "https://cryptologos.cc/logos/polkadot-dot-logo.svg?v=014",
  chainlink: "https://cryptologos.cc/logos/chainlink-link-logo.svg?v=014",
  stellar: "https://cryptologos.cc/logos/stellar-xlm-logo.svg?v=014",
  dogecoin: "https://cryptologos.cc/logos/dogecoin-doge-logo.svg?v=014",
  binancecoin: "https://cryptologos.cc/logos/binance-coin-bnb-logo.svg?v=014",
  solana: "https://cryptologos.cc/logos/solana-sol-logo.svg?v=014",
  uniswap: "https://cryptologos.cc/logos/uniswap-uni-logo.svg?v=014",
  avalanche: "https://cryptologos.cc/logos/avalanche-avax-logo.svg?v=014",
  vechain: "https://cryptologos.cc/logos/vechain-vet-logo.svg?v=014",
  cosmos: "https://cryptologos.cc/logos/cosmos-atom-logo.svg?v=014",
  monero: "https://cryptologos.cc/logos/monero-xmr-logo.svg?v=014",
  tezos: "https://cryptologos.cc/logos/tezos-xtz-logo.svg?v=014",
  aave: "https://cryptologos.cc/logos/aave-aave-logo.svg?v=014",
  algorand: "https://cryptologos.cc/logos/algorand-algo-logo.svg?v=014",
  elrond: "https://cryptologos.cc/logos/elrond-egld-logo.svg?v=014",
  theta: "https://cryptologos.cc/logos/theta-token-theta-logo.svg?v=014",
  dash: "https://cryptologos.cc/logos/dash-dash-logo.svg?v=014",
  chiliz: "https://cryptologos.cc/logos/chiliz-chz-logo.svg?v=014",
  zilliqa: "https://cryptologos.cc/logos/zilliqa-zil-logo.svg?v=014",
  gala: "https://cryptologos.cc/logos/gala-gala-logo.svg?v=014",
  yearn: "https://cryptologos.cc/logos/yearn-finance-yfi-logo.svg?v=014",
  celsius: "https://cryptologos.cc/logos/celsius-cel-logo.svg?v=014",
  hedera: "https://cryptologos.cc/logos/hedera-hashgraph-hbar-logo.svg?v=014",
  filecoin: "https://cryptologos.cc/logos/filecoin-fil-logo.svg?v=014",
  flow: "https://cryptologos.cc/logos/flow-flow-logo.svg?v=014",
  decentraland: "https://cryptologos.cc/logos/decentraland-mana-logo.svg?v=014",
  sushi: "https://cryptologos.cc/logos/sushi-token-sushi-logo.svg?v=014",
  kusama: "https://cryptologos.cc/logos/kusama-ksm-logo.svg?v=014",
  bat: "https://cryptologos.cc/logos/basic-attention-token-bat-logo.svg?v=014",
  iota: "https://cryptologos.cc/logos/iota-iota-logo.svg?v=014",
  phantom: "https://cryptologos.cc/logos/phantom-ftm-logo.svg?v=014",
  waves: "https://cryptologos.cc/logos/waves-waves-logo.svg?v=014",
  nem: "https://cryptologos.cc/logos/nem-xem-logo.svg?v=014",
  nano: "https://cryptologos.cc/logos/nano-nano-logo.svg?v=014",
  ravencoin: "https://cryptologos.cc/logos/ravencoin-rvn-logo.svg?v=014",
  arweave: "https://cryptologos.cc/logos/arweave-ar-logo.svg?v=014",
  serum: "https://cryptologos.cc/logos/srm-token-srm-logo.svg?v=014",
  ocean: "https://cryptologos.cc/logos/ocean-protocol-ocean-logo.svg?v=014",
  celo: "https://cryptologos.cc/logos/celo-celo-logo.svg?v=014",
  holo: "https://cryptologos.cc/logos/holo-hot-logo.svg?v=014",
  aion: "https://cryptologos.cc/logos/aion-aion-logo.svg?v=014",
  horizen: "https://cryptologos.cc/logos/horizen-zen-logo.svg?v=014",
  rgt: "https://cryptologos.cc/logos/rari-governance-token-rgt-logo.svg?v=014",
  bake: "https://cryptologos.cc/logos/bakeryswap-bake-logo.svg?v=014",
  twt: "https://cryptologos.cc/logos/trust-wallet-token-twt-logo.svg?v=014",
};

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${apiURL}/api/news`);
		  console.log("checking news on the frontend"); 
		  console.log(response.data.articles); 
        
        if (response.data && response.data.articles) {
          setNews(response.data.articles);
        } else {
          setError("No news available");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) {
    return <div className="text-center text-xl text-white py-10">Loading news...</div>;
  }

  if (error) {
    return <div className="text-center text-red-500 py-10">Error: {error}</div>;
  }

  return (
    <div className=" mx-auto p-6 bg-gray-900 rounded-lg shadow-lg h-96 overflow-auto">
      <h1 className="text-3xl font-bold text-center text-yellow-400 mb-6">Latest Crypto News</h1>
      <div className="space-y-4">
        {news.map((article, index) => (
          <a
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            key={index}
            className="block p-4 bg-gray-800 rounded-lg transition-transform transform hover:scale-105 shadow-md flex items-center space-x-4"
          >
            <img 
              src={cryptoIcons[article.source.name.toLowerCase()] || cryptoIcons.bitcoin} 
              alt={article.source.name || "crypto icon"} 
              className="w-8 h-8" 
            />
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-teal-400">{article.title}</h2>
              <p className="text-sm text-gray-300">{article.description}</p>
              <p className="mt-2 text-xs text-gray-500">{new Date(article.publishedAt).toLocaleDateString()}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default News;

